import { SliderValues } from '@statsbomb/kitbag-components/types/components/Inputs/Slider/types';

import { useFilters } from '@statsbomb/kitbag-global-football';
import { useTranslation } from 'react-i18next';
import { useUpdateFilters } from '@/hooks/useUpdateFilters';
import { snakeToCamel } from '@/utils/queries';
import { getTranslationColumns } from '@/utils/translations';
import { SliderMultiple } from './SliderMultiple';
import { convertToDisplayValue, convertToSavedValue } from './sliderUtils';

export const MetricDistributionSlider = ({
  metric,
  range,
  step,
  precision,
  isPercentage,
  isReversed,
}: {
  metric: string;
  range: SliderValues;
  step: number;
  precision: number;
  isPercentage: boolean;
  isReversed?: boolean;
}) => {
  const { t } = useTranslation('metrics');
  const { translationKey } = getTranslationColumns(snakeToCamel(metric));
  const [filters] = useFilters('main');
  const { updateFilters } = useUpdateFilters('main');
  const selectedMetricDistributions = filters.metricDistributions;

  const selectedMetric = selectedMetricDistributions.find(({ name }) => name === metric);
  const savedMin = selectedMetric?.min;
  const savedMax = selectedMetric?.max;

  const setSelectedRange = ([min, max]: [number | undefined, number | undefined]) => {
    const updatedSelectedMetricDistributions = selectedMetricDistributions.map(distribution =>
      distribution.name === metric
        ? { ...distribution, min: convertToSavedValue(min, isPercentage), max: convertToSavedValue(max, isPercentage) }
        : distribution,
    );
    updateFilters({ metricDistributions: updatedSelectedMetricDistributions });
  };

  const onDelete = () => {
    const newMetricDistributions = selectedMetricDistributions.filter(({ name }) => name !== metric);
    updateFilters({ metricDistributions: newMetricDistributions });
  };

  const title = t(translationKey);

  return (
    <SliderMultiple
      title={title}
      range={range}
      selectedRange={[
        convertToDisplayValue(savedMin, precision, isPercentage),
        convertToDisplayValue(savedMax, precision, isPercentage),
      ]}
      setSelectedRange={setSelectedRange}
      step={step}
      openEnds="both"
      isReversed={isReversed}
      onDelete={onDelete}
    />
  );
};
